import { withRouter } from 'react-router';
import { withUser } from 'components/queries/GetUserQuery';

import AddPassengersCta from './AddPassengersCta';

export default withRouter(withUser(AddPassengersCta));
